import { useTranslation } from "react-i18next";
import NoData from "@Components/NoData/NoData";
import { useGetDestinationsQuery } from "src/store/apis/pointsExchange";
import ExchangePointCard from "../ExchangePointCard/ExchangePointCard";

const CARDS_SKELETON = Array.from({ length: 10 }).map((_, index) => <ExchangePointCard key={index} loading code="###" />);

export default function ExchangePoints() {
  const { i18n } = useTranslation();
  const { data, isFetching, error } = useGetDestinationsQuery({ page: 1, pageSize: 10000, lang: i18n.language });
  const programs = data;

  if (isFetching) return <div className="grid w-full grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-4 xl:grid-cols-5">{CARDS_SKELETON}</div>;
  if (error || !programs?.length)
    return (
      <div className="flex min-h-[50vh] w-full items-center justify-center">
        <NoData />
      </div>
    );

  return (
    <div className="grid w-full grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-4 xl:grid-cols-5">
      {programs.map((program: any) => (
        <ExchangePointCard key={program.code} {...program} />
      ))}
    </div>
  );
}
